import { Breakpoint } from '@treams/treams-ui';
import { Box } from 'reflexbox';
import styled, { css } from 'styled-components';

const Emoticon = styled(Box)<{ selected: boolean; editable: boolean }>`
	text-align: center;
	opacity: ${(props) => (props.selected ? 1.0 : 0.5)};

	font-size: 24px;
	width: 32px;

	@media screen and (min-width: ${Breakpoint.Medium}) {
		font-size: 32px;
		width: 48px;
	}

	${(props) =>
		props.editable &&
		css`
			cursor: pointer;
			&:hover {
				opacity: 1;
			}
		`};
`;

const EmoticonContainer = styled.div`
	flex-wrap: wrap;
	justify-content: space-between;
	gap: 16px;
	flex-direction: row;
	display: flex;
`;

export default function EmoticonScore({
	choices,
	selected,
	onChange,
	editable = false,
}: {
	choices: Array<string>;
	selected: (index: number) => boolean;
	onChange?: (index: number) => void;
	editable?: boolean;
}) {
	return (
		<EmoticonContainer>
			{choices.map((emoticon, index) => (
				<Emoticon
					key={index}
					selected={selected(index)}
					onClick={() => onChange?.(index)}
					editable={editable}
				>
					{emoticon}
				</Emoticon>
			))}
		</EmoticonContainer>
	);
}
